import { useEffect, useState } from "react";
import { Menu, X, PhoneCall } from "lucide-react";
import { scrollToSection } from "@/App";

const LINKS = [
  { id: "services", label: "About & Services", testId: "nav-link-services" },
  { id: "team", label: "Leadership", testId: "nav-link-team" },
  { id: "work", label: "Past Impact", testId: "nav-link-work" },
  { id: "plans", label: "Association Plans", testId: "nav-link-plans" },
  { id: "calculator", label: "Funding Estimator", testId: "nav-link-calculator" },
  { id: "faq", label: "FAQ", testId: "nav-link-faq" },
];

export default function Navbar({ onRequestCallback }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  const solid = scrolled || open;

  return (
    <header
      data-testid="header-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        solid
          ? "border-b border-[#E6E9E6] bg-white/85 shadow-sm backdrop-blur-xl"
          : "border-b border-transparent bg-white/40 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <a
          data-testid="header-logo-link"
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            if (window.__lenis) window.__lenis.scrollTo(0);
            else window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2.5"
        >
          <img
            src="/assets/logo.png"
            alt="Impact Sutra — From Intent to Impact"
            className="h-16 w-auto sm:h-20"
          />
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testId}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-600 transition-colors hover:text-[#0E2A6B]"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <span className="hidden items-center gap-1.5 rounded-full border border-[#C7DAF5] bg-[#EAF1FC] px-3 py-1 text-xs font-semibold uppercase tracking-[0.12em] text-[#0E2A6B] xl:inline-flex">
            Empowering NGOs Across India
          </span>
          <button
            data-testid="nav-cta-request-callback"
            onClick={onRequestCallback}
            className="inline-flex items-center gap-2 rounded-full bg-[#0E2A6B] px-5 py-2.5 text-sm font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-[#0A1F50] hover:shadow-lg"
          >
            <PhoneCall className="h-4 w-4" />
            Request Callback
          </button>
        </div>

        <button
          data-testid="nav-mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-lg p-2 text-slate-700 lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="border-t border-[#E6E9E6] bg-white px-4 py-4 lg:hidden">
          <div className="flex flex-col gap-1">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testId}-mobile`}
                onClick={() => go(l.id)}
                className="rounded-lg px-3 py-2.5 text-left text-sm font-medium text-slate-700 hover:bg-[#F4F3EE]"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="nav-cta-request-callback-mobile"
              onClick={() => {
                setOpen(false);
                onRequestCallback();
              }}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-[#0E2A6B] px-5 py-3 text-sm font-semibold text-white"
            >
              <PhoneCall className="h-4 w-4" />
              Request Callback
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
